import {Datepicker} from '@esgi/ui/icons';
import {TabItem} from '../../../../kit';
import {TabID} from './types';

export const tabs: TabItem<TabID>[] = [
	{value: TabID.Indefinitely, content: 'Indefinitely'},
	{value: TabID.Period, content: 'Period'},
	{value: TabID.CustomDateRange, content: Datepicker},
];
